import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(CustomEase);
CustomEase.create("myEase", "M0,0 C0.467,0.011 0.187,1 1,1");

class Animation {
  constructor() {
    this.startpageRoot = document.querySelector(".startpage");

    if (!this.startpageRoot) return;

    this.overlay = this.ensureOverlay();
    this.playIntro();
  }

  ensureOverlay() {
    let overlay = document.getElementById("overlay");

    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "overlay";
      overlay.setAttribute("aria-hidden", "true");
      document.body.prepend(overlay);
    }

    return overlay;
  }

  playIntro() {
    gsap.killTweensOf(this.overlay);
    const heroContent = this.startpageRoot.querySelector(
      ".lc-hero-image__content-container"
    );
    const heroItems = this.startpageRoot.querySelectorAll(
      ".lc-hero-image__content-container > *"
    );

    // document.body.style.overflow = "hidden";

    gsap.set(this.overlay, {
      yPercent: 0,
      autoAlpha: 1,
    });

    if (heroContent) {
      gsap.set(heroContent, {
        position: "relative",
        zIndex: 10,
      });
    }

    gsap.set(heroItems, {
      position: "relative",
      zIndex: 11,
    });

    gsap.fromTo(
      heroItems,
      {
        opacity: 0,
        y: 40,
      },
      {
        duration: 1,
        opacity: 1,
        y: 0,
        stagger: 0.2,
        ease: "power3.inOut",
        immediateRender: false,
        onComplete: () => {
          gsap.to(this.overlay, {
            duration: 1.6,
            yPercent: -100,
            ease: "myEase",
            onComplete: () => {
              if (this.overlay && this.overlay.parentNode) this.overlay.remove();
              gsap.set(heroItems, {
                clearProps: "zIndex",
              });
              if (heroContent) {
                gsap.set(heroContent, {
                  clearProps: "zIndex",
                });
              }
            },
          });
        },
      }
    );
  }
}

export default Animation;
